import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import {
  faHouse,
  faHome,
  faCompass,
  faThumbsUp,
  faClockRotateLeft,
  faClock,
  faUser,
  faMagnifyingGlass,
  faEllipsisVertical,
  faCircleExclamation,
  faClose,
  faPlus,
  faTrash,
  faShareAlt,
  faPen,
  faEye,
  faEyeSlash,
  faUpload,
  faMoon,
  faSun,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  fab,
  faHouse,
  faCompass,
  faThumbsUp,
  faClockRotateLeft,
  faClock,
  faUser,
  faHome,
  faMagnifyingGlass,
  faEllipsisVertical,
  faCircleExclamation,
  faClose,
  faPlus,
  faTrash,
  faShareAlt,
  faPen,
  faEye,
  faEyeSlash,
  faUpload,
  faMoon,
  faSun
);

export { library };
